export default "dist/images/block-number-box-plain.8feb9ea.png";